import React from "react";

export default function Web_Frontend() {
  return (
    <div>
      <h1>What is Front-End Dev.</h1>
      <p>
        Route: <code>/web/frontend</code>
      </p>
      <p>Auto-generated component.</p>
    </div>
  );
}
